import { render, staticRenderFns } from "./-sell-geo.vue?vue&type=template&id=39dd45b2"
import script from "./-sell-geo.vue?vue&type=script&lang=js"
export * from "./-sell-geo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports